import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../contexts/auth';
import { sendMonitorNotif } from '../../../services/analyticsService';
import { useInternationalization } from '../../../contexts/internationalization';
// import Modal from '../../listing/Modal';
import TranslationDropdown from '../TranslationDropdown';
import CurrencyDropdown from './CurrencyDropdown';
import Modal2 from '../../listing/Modal2';

const Hamburger = () => {
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  const appToken = localStorage.getItem('@App:token');
  const { currency } = useInternationalization();

  const initialBtnMenuClass = 'block hamburger md:hidden focus:outline-none text-red-500';
  const initialMenuClass = `flex absolute flex-col font-medium pb-8 pl-8 space-y-5
     font-light text-base text-defaultText bg-white w-full shadow-md right-0 overflow-y-auto`;
  const [isToggleOn, setIsToggleOn] = useState(false);
  const [menuBtnClass, setMenuBtnClass] = useState(initialBtnMenuClass);
  const [showModal, setShowModal] = useState(false);

  const Btn = () => {
    const handleClick = async () => {
      setShowModal(true);
    };

    return (
      <button
        onClick={handleClick}
        className="flex items-center bg-white justify-center cursor-pointer px-6 "
      >
        {currency}
      </button>
    );
  };

  const handleToggle = () => {
    setIsToggleOn(!isToggleOn);
    setMenuBtnClass(isToggleOn ? initialBtnMenuClass : initialBtnMenuClass.concat(' ', 'open'));
    // setMenuClass(
    // isToggleOn ? initialMenuClass.concat(' ', 'hidden') : initialMenuClass.concat(' ', 'flex')
    // );
  };

  // TODO: find a fix. menu always open on mobile when visiting a page
  //   useEffect(() => {
  //     setMenuClass(initialMenuClass.concat(' ', 'hidden'));
  //   }, []);

  useEffect(() => {
    setIsToggleOn(false);
    setMenuBtnClass(initialBtnMenuClass);
    // setMenuClass(initialMenuClass.concat(' ', 'hidden'));
  }, [location.pathname]); // reset on route change

  return (
    <>
      <div className="flex  items-end pb-1 justify-center">
        <button
          className={menuBtnClass}
          onClick={handleToggle}
          aria-label="Toggle menu"
          aria-expanded={isToggleOn}
          aria-controls="mobile-menu"
        >
          <span className="hamburger-top"></span>
          <span className="hamburger-middle"></span>
          <span className="hamburger-bottom"></span>
        </button>
        <div
          id="mobile-menu"
          className={`fixed top-12 left-0 right-0 bottom-0 z-50 flex flex-col bg-white p-8 space-y-5 transition-transform duration-300 ${
            isToggleOn ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div
            className={`${initialMenuClass} overflow-y-auto pb-56 overscroll-contain`}
            style={{ height: 'calc(100vh - 4rem)' }}
          >
            <Link onClick={handleToggle} to="/">
              {t('Home')}
            </Link>
            <a href="/how-it-works">{t('How it works')}</a>
            {currentUser && (
              <>
                <Link onClick={handleToggle} to="/users/dashboard">
                  Your profile
                </Link>
                <Link onClick={handleToggle} to="/users/manage-listings">
                  {t('Property listings')}
                </Link>
                <Link onClick={handleToggle} to="/hunting-board/dashboard/user">
                  {t('Hunting board')}
                </Link>
              </>
            )}
            <Link
              onClick={() => {
                sendMonitorNotif({
                  type: 'CREATE-LISTING',
                  source: 'HAMBURGER',
                  userId: currentUser?.id,
                });
                handleToggle();
              }}
              to="/create-property"
            >
              {t('List property')}
            </Link>
            <Link
              onClick={() => {
                sendMonitorNotif({
                  type: 'CREATE-HUNT',
                  source: 'HAMBURGER',
                  userId: currentUser?.id,
                });
                handleToggle();
              }}
              to="/hunting-board/create-hunt/user"
            >
              {t('Hunt property')}
            </Link>
            <Link
              to=""
              onClick={() =>
                window.open(`${import.meta.env.VITE_MESSENGER_URL}?token=${appToken}`, '_blank')
              }
            >
              Pulse | Dedicated Chat App
            </Link>
            <div className="w-full pr-8">
              <hr className="w-full  border-t border-deehiy" />
            </div>
            <a href="/content-policy">{t('Content Policy')}</a>
            <a href="/custom-url-policy">{t('Custom URL policy')}</a>
            <a href="/listing-guidelines">{t('Listing Guidelines')}</a>
            <a href="/privacy-policy">{t('Privacy Policy')}</a>
            <a href="/terms-of-service">{t('Terms of Service')}</a>
            {/* <a href="/news">{t('News')}</a> */}
            <a href="/listing">{t('Listing')}</a>
            {/* <a href="/forms">{t('Forms')}</a> */}
            {/* <a href="/network">{t('Network')}</a> */}
            <div className="w-full pr-8">
              <hr className="w-full  border-t border-deehiy" />
            </div>
            <a href="/help">{t('Help Center')}</a>
            <div className="text-sm">
              <div className="flex gap-x-2 items-center">
                language: <TranslationDropdown />
              </div>
              <div className="flex pt-2 gap-x-2 items-center">
                currency: <Btn />
              </div>
            </div>
            {!currentUser && (
              <div className="flex w-full justify-evenly">
                <Link
                  onClick={handleToggle}
                  to="/login"
                  // state={{ redirectTo: location }}
                  className="inline-block px-4 py-2 bg-white text-deehiy rounded border border-deehiy"
                >
                  {t('Login')}
                </Link>
                <Link
                  onClick={handleToggle}
                  to="/register"
                  className="inline-block px-4 py-2 bg-deehiy text-white rounded"
                >
                  {t('Sign up')}
                </Link>
              </div>
            )}
            <div className="pb-36"></div> {/* Forces bottom padding */}
          </div>
        </div>
      </div>
      {showModal && (
        <Modal2 showModal={showModal} setShowModal={setShowModal}>
          <CurrencyDropdown
            onClose={() => {
              setShowModal(false);
            }}
          />
        </Modal2>
      )}
    </>
  );
};

export default Hamburger;
